import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {Button, withConfirm, ConfirmProps} from '@deviceinsight/ng-ui-basic-components';
import hasAuthority from '../../common/hasAuthority';
import {AUTHORITY_UPDATE_RULE} from '../../../modules/ruleengine/config/consts';
type TriggerResetButtonProps = {
	onReset: () => void;
};
type Props = TriggerResetButtonProps & ConfirmProps;
const confirmResetTitle = {
	id: 'ruleengine.triggerDetails.confirmResetTitle',
	defaultValue: 'Reset Counter'
};
const confirmResetBody = {
	id: 'ruleengine.triggerDetails.confirmResetBody',
	defaultValue: 'Do you really want to reset the counter back to 0?'
};

const TriggerResetButton = ({onReset, confirm}: Props) => {
	const canReset = hasAuthority(AUTHORITY_UPDATE_RULE);

	if (!canReset) {
		return null;
	}

	const onClick = async () => {
		await confirm(confirmResetTitle, confirmResetBody);
		onReset();
	};

	return (
		<Button primary data-testid="trigger-reset-button" onClick={onClick}>
			<Trans i18nKey="ruleengine.triggerDetails.reset">Reset</Trans>
		</Button>
	);
};

export default withConfirm(TriggerResetButton);
